import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useState } from "react";
import { createTask } from "../../../core/api/useTask";
import CommonSelect from "../../../core/common/commonSelect";
import { Link } from "react-router-dom";
import { getProjects, Project } from "../../../core/api/useTask";
import {
  Employee,
  fetchProjectEmployees,
} from "../../../core/api/useProjectMapping";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuthToken } from "../../../core/data/redux/useAuthToken";

const statusChoose = [
  { value: "Select", label: "Select" },
  { value: "Inprogress", label: "Inprogress" },
  { value: "Completed", label: "Completed" },
  { value: "Pending", label: "Pending" },
  { value: "Onhold", label: "Onhold" },
];

const priorityChoose = [
  { value: "Select", label: "Select" },
  { value: "Critical", label: "Critical" },
  { value: "High", label: "High" },
  { value: "Medium", label: "Medium" },
  { value: "Low", label: "Low" },
];

const TaskSchema = Yup.object().shape({
  task_name: Yup.string()
    .matches(/^[\w@]+$/, "Only letters, numbers, underscores, and @ are allowed")
    .required("Required"),

  project_id: Yup.string().required("Required"),

  Assign_to: Yup.string().required("Required"),

  start_date: Yup.date().required("Required"),

  end_date: Yup.date()
    .required("Required")
    .min(Yup.ref("start_date"), "End Date must be after Start Date"),

  due_date: Yup.date()
    .required("Required")
    .min(Yup.ref("start_date"), "Due Date must be after or on Start Date")
    .max(Yup.ref("end_date"), "Due Date must be before or on End Date"),

  estimated_hours: Yup.number()
    .typeError("Must be a numeric value")
    .min(0, "Must be a positive number")
    .required("Required"),

  priority: Yup.string().required("Required"),

  status: Yup.string().required("Required"),

  descriptions: Yup.string()
    .max(200, "Description must be under 200 characters"),
});

const AddTaskModal = () => {
  const [uploadFile, setUploadFile] = useState<File | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [view, setView] = useState(1);
    const empToken = useAuthToken();
  const [projectOptions, setProjectOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [projects, setProjects] = useState<Project[]>([]);
  const [employeeDetailsMap, setEmployeeDetailsMap] = useState<
    Record<string, Employee>
  >({});
  const [assignedOptions, setAssignedOptions] = useState<
    { label: string; value: string; group: string }[]
  >([]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        toast.error("❌ File must be under 5 MB");
        setErrorMessage("File must be under 5 MB");
        return;
      }
      setUploadFile(file);
      setErrorMessage(null);
    }
  };

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const data: Project[] = await getProjects(empToken);
        const formattedProjects = data.map((project) => ({
          label: project.name,
          value: project.id,
        }));

        setProjects(data);
        setProjectOptions(formattedProjects);
      } catch (error) {
        console.error("Failed to fetch projects:", error);
      }
    };

    fetchProjects();
  }, []);

  useEffect(() => {
    fetchProjectEmployees()
      .then((employees: Employee[]) => {
        const map: Record<string, Employee> = {};
        employees.forEach((emp) => {
          map[emp.employee_id] = emp;
        });
        setEmployeeDetailsMap(map);
      })
      .catch((err) => {
        console.error("Failed to fetch project employees", err);
      });
  }, []);

  return (
    <>
      <Link
        to="#"
        data-bs-toggle="modal"
        data-bs-target="#add_task"
        className="btn btn-primary d-flex align-items-center"
      >
        <i className="ti ti-circle-plus me-2" />
        Add Task
      </Link>

      <Formik
        initialValues={{
          task_name: "",
          project_id: "",
          Assign_to: "",
          due_date: "",
          tags: [],
          priority: "",
          status: "",
          view: 1,
          descriptions: "",
          start_date: "",
          end_date: "",
          estimated_hours: "",
        }}
        validationSchema={TaskSchema}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          try {
            if (
              new Date(values.due_date) < new Date(values.start_date) ||
              new Date(values.due_date) > new Date(values.end_date)
            ) {
              toast.error("❌ Due Date must be between Start and End Date");
              return;
            }
            const formData = new FormData();
            formData.append("task_name", values.task_name);
            formData.append("project_id", values.project_id);
            formData.append("Assign_to", values.Assign_to);
            formData.append("due_date", values.due_date.split("T")[0]);
            formData.append("priority", values.priority);
            formData.append("status", values.status);
            formData.append("view", view.toString());
            formData.append("start_date", values.start_date.split("T")[0]);
            formData.append("end_date", values.end_date.split("T")[0]);
            formData.append(
              "estimated_hours",
              String(values.estimated_hours || 0)
            );
            formData.append("descriptions", values.descriptions || "");

            if (uploadFile) {
              formData.append("upload_file", uploadFile);
            }

            if (values.tags && values.tags.length > 0) {
              values.tags.forEach((tag) => formData.append("tags", tag));
            } else {
              formData.append("tags", "");
            }
            await createTask(empToken,formData);
            toast.success("✅ Task created successfully");
            const modalElement = document.getElementById("add_task");
            const modalInstance = (window as any).bootstrap?.Modal.getInstance(
              modalElement
            );
            modalInstance?.hide();
            resetForm();
            setUploadFile(null);
          } catch (error) {
            toast.error("❌ Failed to create task");
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({ values, setFieldValue, setFieldTouched, isSubmitting }) => (
          <Form>
            <div className="modal fade" id="add_task">
              <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h4 className="modal-title">Add New Task</h4>
                    <button
                      type="button"
                      className="btn-close custom-btn-close"
                      data-bs-dismiss="modal"
                    >
                      <i className="ti ti-x" />
                    </button>
                  </div>

                  <div className="modal-body">
                    <div className="row">
                      <div className="col-12">
                        <div className="mb-3">
                          <label className="form-label">Title</label>
                          <Field
                            type="text"
                            name="task_name"
                            className="form-control"
                          />
                          <ErrorMessage
                            name="task_name"
                            component="div"
                            className="text-danger small mt-1"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Due Date</label>
                          <DatePicker
                            className="form-control datetimepicker"
                            selected={values.due_date ? new Date(values.due_date) : null}
                            onChange={(date: Date | null) => {
                              setFieldValue("due_date", date ? date.toISOString() : "");
                              setFieldTouched("due_date", true); // 👈 Add this line!
                            }}
                            placeholderText="DD-MM-YYYY"
                          />
                          <ErrorMessage
                            name="due_date"
                            component="div"
                            className="text-danger small mt-1"
                          />

                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Project</label>
                          <CommonSelect
                            className="select"
                            options={projectOptions}
                            onChange={(opt: any) => {
                              setFieldValue("project_id", opt.value);

                              const selectedProject = projects.find(
                                (p) => p.id === opt.value
                              );
                              if (selectedProject) {
                                const assigned = [
                                  ...(selectedProject.projectLeadIds || []).map(
                                    (id) => ({
                                      label: `Lead - ${employeeDetailsMap[id]?.username || id
                                        }`,
                                      value: id,
                                      group: "Team Lead",
                                    })
                                  ),
                                  ...(
                                    selectedProject.projectMemberIds || []
                                  ).map((id) => ({
                                    label: `Member - ${employeeDetailsMap[id]?.username || id
                                      }`,
                                    value: id,
                                    group: "Team Member",
                                  })),
                                ];
                                setAssignedOptions(assigned);
                              }
                            }}
                          />
                          <ErrorMessage
                            name="project_id"
                            component="div"
                            className="text-danger small mt-1"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label me-2">Assigned To</label>
                          <CommonSelect
                            className="select"
                            options={assignedOptions}
                            onChange={(opt: any) =>
                              setFieldValue("Assign_to", opt.value)
                            }
                          />
                          <ErrorMessage
                            name="Assign_to"
                            component="div"
                            className="text-danger small mt-1"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Status</label>
                          <CommonSelect
                            className="select"
                            options={statusChoose}
                            onChange={(opt: any) =>
                              setFieldValue("status", opt.value)
                            }
                            defaultValue={statusChoose[1]}
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Start Date</label>
                          <DatePicker
                            className="form-control datetimepicker"
                            selected={
                              values.start_date
                                ? new Date(values.start_date)
                                : null
                            }
                            onChange={(date: Date | null) =>
                              setFieldValue(
                                "start_date",
                                date ? date.toISOString() : ""
                              )
                            }
                            placeholderText="DD-MM-YYYY"
                          />
                          <ErrorMessage
                            name="start_date"
                            component="div"
                            className="text-danger small mt-1"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">End Date</label>
                          <DatePicker
                            className="form-control datetimepicker"
                            selected={values.end_date ? new Date(values.end_date) : null}
                            onChange={(date: Date | null) => {
                              setFieldValue("end_date", date ? date.toISOString() : "");
                              setFieldTouched("end_date", true); // Ensures Formik shows validation error
                            }}
                            placeholderText="DD-MM-YYYY"
                          />
                          <ErrorMessage
                            name="end_date"
                            component="div"
                            className="text-danger small mt-1"
                          />
                        </div>
                      </div>

                      <div className="col-md-12">
                        <label className="form-label">
                          Who Can See this Task?
                        </label>
                        <div className="d-flex align-items-center mb-3">
                          {[1, 2, 3].map((val) => (
                            <div key={val} className="form-check me-3">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="view"
                                onChange={() => setView(val)}
                                checked={view === val}
                              />
                              <label className="form-check-label text-dark">
                                {val === 1
                                  ? "Public"
                                  : val === 2
                                    ? "Private"
                                    : "Admin Only"}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Estimated Hours</label>
                          <Field
                            type="number"
                            name="estimated_hours"
                            className="form-control"
                            placeholder="Enter estimated hours"
                            min="0"
                            step="0.1"
                          />
                          <ErrorMessage
                            name="estimated_hours"
                            component="div"
                            className="text-danger small mt-1"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Priority</label>
                          <CommonSelect
                            className="select"
                            options={priorityChoose}
                            onChange={(opt: any) =>
                              setFieldValue("priority", opt.value)
                            }
                            defaultValue={priorityChoose[1]}
                          />
                          <ErrorMessage
                            name="priority"
                            component="div"
                            className="text-danger small mt-1"
                          />
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div className="mb-3">
                          <label className="form-label">Descriptions</label>
                          <Field
                            as="textarea"
                            name="descriptions"
                            className="form-control"
                            rows={4}
                            placeholder="Write task description..."
                          />
                          <ErrorMessage
                            name="descriptions"
                            component="div"
                            className="text-danger small mt-1"
                          />
                        </div>
                      </div>

                      <div className="col-md-12">
                        <label className="form-label">Upload Attachment</label>
                        <div className="bg-light rounded p-2">
                          <div className="profile-uploader border-bottom mb-2 pb-2">
                            <div className="drag-upload-btn btn btn-sm btn-white border px-3">
                              Select File
                              <input
                                type="file"
                                className="form-control image-sign"
                                onChange={handleFileChange}
                              />
                            </div>
                          </div>
                          {errorMessage && (
                            <div className="alert alert-danger">
                              {errorMessage}
                            </div>
                          )}

                          {uploadFile && (
                            <div className="d-flex align-items-center justify-content-between border-bottom mb-2 pb-2">
                              <div className="d-flex align-items-center">
                                <h6 className="fs-12 fw-medium me-1">
                                  {uploadFile.name}
                                </h6>
                                <span className="badge badge-soft-info">
                                  {Math.round(uploadFile.size / 1024)} KB
                                </span>
                              </div>
                              <Link
                                to="#"
                                className="btn btn-sm btn-icon"
                                onClick={() => setUploadFile(null)}
                              >
                                <i className="ti ti-trash" />
                              </Link>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={isSubmitting}

                    >
                      {isSubmitting ? "Adding..." : "Add New Task"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AddTaskModal;
